import { noop } from '@fabric-app/utils/guards/noop';
import { useLayoutEffect } from 'react';

const useClientLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : noop;

export { useClientLayoutEffect };
//# sourceMappingURL=useClientLayoutEffect.js.map
